<app-grid
    [columns]="columns"
    #orignRef 
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [multiSelect]="false"
    [gridName]="gridName"
    [allowAdd]="false"
    [allowEdit]="false" 
    [allowView]="false" 
    [allowDelete]="false"
    (refreshDataFromServer)="refreshData()"
    (rowSelected)="onRowClick($event)"
    (exportClicked)="exportFlagsClicked()"

></app-grid>
